import axiosInstance from '../config/axios';
import type { APIResp } from '../types/APIService';
import type { NewUser, User, UserLogin } from '../types/User';

export async function createUser(payload: NewUser) {
  try {
    await axiosInstance.post('/register', payload);
    return true;
  }
  catch {
    return false;
  }
}

export async function loginUser(payload: UserLogin) {
  try {
    const res = await axiosInstance.post<APIResp<User>>('/login', payload);
    return res.data.data;
  }
  catch {
    return null;
  }
}

export async function logoutUser() {
  try {
    const res = await axiosInstance.post<APIResp<any>>('/logout', {});
    return res.data.data;
  }
  catch {
    return null;
  }
}

export async function triggerForgottenPass(email: string): Promise<boolean> {
  try {
    await axiosInstance.post<APIResp<any>>('/forgotten-password', { email });
    return true;
  }
  catch {
    return false;
  }
}

export async function resetPassword(body: { password: string, confirm_password: string }, tkn: string): Promise<boolean> {
  try {
    await axiosInstance.post<APIResp<any>>('/reset-password', body, { params: { tkn } });
    return true;
  }
  catch {
    return false;
  }
}
